import { LightSwitchOffIcon } from './LightSwitchOffIcon';

/**
 * author: Matthias de Baat
 * id 39A7777B-C9F7-4468-95B0-FE0037A635E9
 * name light-switch-off
 * version: 6.6.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/light-switch-off.svg
 * tags
 * - Home Automation 
 */
export const RockerSwitchOffIcon = LightSwitchOffIcon;
export default RockerSwitchOffIcon